export default {
  nav: {
    title: 'Direct Secure Transfer',
  }
}
